import React, { useContext } from 'react';
import { StepsContext } from './Steps'; 
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2'; 

const Chart = () => {
    const { chartLabels, chartData } = useContext(StepsContext); 

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
    );

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'Consumption',
    },
  },
};

const labels = chartLabels;

const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: 'Kiloliters',
        data: chartData,
        borderColor: 'rgb(75, 192, 192)', // Greenish
        backgroundColor: 'rgba(75, 192, 192, 0.5)', // Greenish with alpha
      },
    ],
  };
  
  return <Line options={options} data={data} />;
}

export default Chart;